export default __webpack_public_path__ + "static/media/left-camera.086c7b06.gif";